// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TmUtl","footer":"styles_footer__2-DXH"};